import TitlePubDateType from '../components/Title/TitlePubDateType';

/**
 *
 * @param {Number} num
 * @param {String} label
 * Converts given label into plural if applicable
 */
export const toPlural = (num, label) => {
	const n = typeof num === 'number' ? num : Number(num);

	const base = `${n.toLocaleString()} ${label}`;

	return n === 1 ? base : `${base}s`;
};

export const formatAsDollarValue = value => {
	if (!value) return '$ 0';
	const val = typeof value === 'number' ? value.toString() : value;
	return `$ ${val}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

/**
 *
 * @param {Array} sourceArray
 * @param {String} property
 * @returns {Object}
 * Creates a map of array items by the found values of the given 'property'
 */
export const groupBy = (sourceArray, property) => {
	return sourceArray.reduce((accumulator, nextItemInSourceArray) => {
		const valueAtProperty = nextItemInSourceArray[property];

		if (!accumulator[valueAtProperty]) {
			accumulator[valueAtProperty] = [];
		}

		accumulator[valueAtProperty].push(nextItemInSourceArray);
		return accumulator;
	}, {});
};

/**
 *
 * @param {Object} apiResponse
 * @returns {Object}
 * Creates a map of array items by the found values of the given 'property'
 */
export const createTitleObject = apiResponse => {
	const {
		products,
		digitalCopyInfo,
		downloadableSkus,
		requestablePrcSkus,
		requestableSkus,
		userCommunitySummaryReviews,
		sharedMarkupNotes,
		reviews,
		downloads,
		requests,
		shelves,
	} = apiResponse;
	if (products) {
		return products.map((product, idx) => {
			const availableReviewCopyFormats = digitalCopyInfo
				? digitalCopyInfo.filter(dci => dci.sku === product.sku)
				: [];

			if (
				availableReviewCopyFormats &&
				availableReviewCopyFormats.length &&
				availableReviewCopyFormats[0]
			) {
				var availableReviewCopyFormat = availableReviewCopyFormats[0];
				product.digitalCreatedDate =
					availableReviewCopyFormat.createdDate;
				product.digitalUpdatedDate =
					availableReviewCopyFormat.updatedDate;
			}

			const isRequestable =
				requestableSkus &&
				requestableSkus.filter(rs => rs === product.sku)[0];
			const isDownloadable =
				downloadableSkus &&
				downloadableSkus.filter(dl => dl === product.sku)[0];

			product.reviewCopyAvailability = isDownloadable
				? 'Available for Download'
				: isRequestable
				? 'Available for Request'
				: 'Review Copy Not Available';
			const isPrcRequestable =
				requestablePrcSkus &&
				requestablePrcSkus.filter(sku => sku === product.sku)[0];
			const markupNotes =
				sharedMarkupNotes &&
				sharedMarkupNotes.filter(n => n.value && n.sku === product.sku);
			const csr =
				userCommunitySummaryReviews &&
				userCommunitySummaryReviews.filter(
					csr => csr.sku === product.sku,
				);
			var communityReviews = 0;
			var average = 0;
			var pubDatePeriod = '';
			if (csr && csr.length > 0) {
				communityReviews = csr[0].count;
				average = csr[0].rating && csr[0].rating.toFixed(1);
			}
			pubDatePeriod = getPubDatePeriod(product.pubDate);
			product.markupNotes =
				markupNotes && markupNotes.length > 0 && markupNotes;
			product.markupNoteIndicator =
				markupNotes && markupNotes.length > 0
					? 'Has Markup Note'
					: 'No Markup Note';
			product.sequence = idx;
			product.key = product.sku;
			product.reviews = communityReviews;
			product.average = average;
			product.pubDatePeriod = pubDatePeriod;
			product.pubDatePeriodDisplay = TitlePubDateType[pubDatePeriod]
				? TitlePubDateType[pubDatePeriod].label
				: 'Unknown';
			const review =
				reviews && reviews.filter(rev => rev.sku === product.sku)[0];
			const download =
				downloads &&
				downloads.filter(rev => rev.sku === product.sku)[0];
			const request =
				requests && requests.filter(rev => rev.sku === product.sku)[0];
			const shelf =
				shelves && shelves.filter(she => she.sku === product.sku)[0];
			return {
				...product,
				product,
				...review,
				...download,
				...request,
				...shelf,
				isPrcRequestable,
				isRequestable,
				isDownloadable,
				availableReviewCopyFormats,
				uri:
					product &&
					product.images &&
					product.images.filter(im => im.type === 'jacketCover')
						.length > 0 &&
					product.images.filter(im => im.type === 'jacketCover')[0]
						.uri + '?height=450',
			};
		});
	}
};

const getPubDatePeriod = pubDate => {
	var pubDatePeriod = '';
	var titlePubDate = new Date(pubDate);
	Object.keys(TitlePubDateType).map(listType => {
		var today = new Date();
		const lowEnd = new Date(
			today.setMonth(
				today.getMonth() + TitlePubDateType[listType].monthsFrom,
			),
		);
		today = new Date();
		const highEnd = new Date(
			today.setMonth(
				today.getMonth() + TitlePubDateType[listType].monthsTo,
			),
		);
		if (titlePubDate > lowEnd && titlePubDate <= highEnd) {
			pubDatePeriod = TitlePubDateType[listType].key;
		}
	});
	return pubDatePeriod;
};
